// Helper functions moved to outer scope for better performance
function checkValueContainsSubPath(value, subPath) {
  if (typeof value === 'object' && value !== null) {
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        if (key === subPath) {
          return true;
        }
        if (typeof value[key] === 'object') {
          if (checkValueContainsSubPath(value[key], subPath)) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

export function checkPathContainsSubPath(data, subPath, fullPath, secoundData) {
  const splitUrl = fullPath?.split('/') || [];

  if (!data || !Array.isArray(data)) {
    return false;
  }

  for (const item of data) {
    let valueToCheck = item.oldValue;
    const pathToCheck = item.path;
    if (valueToCheck === null) {
      valueToCheck = item.newValue;
    }

    for (let i = 1; i < splitUrl.length; i++) {
      const key = splitUrl[i];
      if (pathToCheck === `/${key}`) {
        if (secoundData != undefined || secoundData != null) {
          for (const item2 of secoundData) {
            let valueToCheck2 = item2.oldValue;
            const pathToCheck2 = item2.path;
            if (valueToCheck2 === null) {
              valueToCheck2 = item2.newValue;
            }
            if (fullPath == pathToCheck2) {
              return false;
            }
          }
        }
        return true;
      }
    }
    if (fullPath == pathToCheck) {
      return true;
    }
  }
  return false;
}

function extractLastPathSegment(path) {
  if (path == undefined || path == null) return '';
  const segments = path.split('/');
  return segments.at(-1);
}

// helpers for path validation
export const getInvalidObject = (invalidpath, pathKey) => invalidpath?.find((item) => item.path === pathKey);

export const getValidObject = (updatepath, pathKey) => updatepath?.find((item) => item.path === pathKey);

// color logic
export const getTypographyColor = (
  type,
  key,
  invalidpath,
  updatepath,
  height,
  authorized,
  unauthorized,
  validobject,
  invalidobject
) => {
  if (type === 'add') return '';

  if (
    (height === 1 && authorized) ||
    validobject ||
    checkPathContainsSubPath(updatepath, extractLastPathSegment(key), key, invalidpath)
  )
    return 'green';

  if (
    checkPathContainsSubPath(invalidpath, extractLastPathSegment(key), key, updatepath) ||
    (height === 1 && unauthorized) ||
    invalidobject
  )
    return 'red';

  return '';
};

// status text
export const getStatusText = (
  type,
  key,
  invalidpath,
  updatepath,
  height,
  authorized,
  unauthorized,
  validobject,
  invalidobject
) => {
  if (type === 'add') return '';

  if (
    (height === 1 && authorized) ||
    validobject ||
    checkPathContainsSubPath(updatepath, extractLastPathSegment(key), key, invalidpath)
  )
    return '(Authorized change detected)';

  if (
    checkPathContainsSubPath(invalidpath, extractLastPathSegment(key), key, updatepath) ||
    (height === 1 && unauthorized) ||
    invalidobject
  )
    return '(Unauthorized change detected)';

  return '';
};

// input style builder
export const getInputStyles = (
  type,
  key,
  invalidpath,
  updatepath,
  height,
  authorized,
  unauthorized,
  validobject,
  invalidobject
) => {
  if (type === 'add') return {};

  const greenCond =
    (height === 1 && authorized) ||
    validobject ||
    checkPathContainsSubPath(updatepath, extractLastPathSegment(key), key, invalidpath);

  const redCond =
    checkPathContainsSubPath(invalidpath, extractLastPathSegment(key), key, updatepath) ||
    (height === 1 && unauthorized) ||
    invalidobject;

  return {
    borderRadius: greenCond || redCond ? 'var(--main-system-4-px, 4px)' : '',
    border: greenCond ? '1px solid var(--red-500, #4c9a34)' : redCond ? '1px solid var(--red-500, #FF293F)' : '',
    backgroundColor: greenCond ? 'var(--yellow-100, #dcffd7)' : redCond ? 'var(--yellow-100, #FFF2C6)' : '',
  };
};
